import React from 'react';
import { CheckCircle } from 'lucide-react';

const ConsentSuccess = ({ consentId, onClose }) => (
  <div className="text-center py-8">
    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <CheckCircle className="h-10 w-10 text-green-600" />
    </div>
    <h3 className="text-xl font-semibold text-gray-900 mb-2">Consent Recorded Successfully!</h3>
    <p className="text-gray-600 mb-4">
      The video consent has been securely stored and is legally valid.
    </p>
    <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-sm text-green-800 mb-6">
      <div className="font-medium">Consent ID: {consentId}</div>
      <div>This ID can be used for legal reference and audit purposes.</div>
    </div>
    <button
      onClick={onClose}
      className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
    >
      Done
    </button>
  </div>
);

export default ConsentSuccess;
